<template>
  <section class="page-container">
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          v-for="(value,i) in statistics"
          :key="i"
          class="item">
          <span class="num">{{value.val}}</span>
          <span>{{value.name}}</span>
        </div>
      </div>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Ref., Recipient, Phone No., Tracking No."
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <div class="flex-sb">
              <div class="form-half">
                <v-checkbox-group
                  v-model="status"
                  :list="noClaimStatusList"
                  @change="filterData">
                  <template #default="{ item }">
                    <span class="flex-sb-center">
                      <span
                        class="circle"
                        :class="{
                          'blue': item.id == 1,
                          'red': item.id == 3,
                          'green': [2].includes(item.id),
                        }"></span>
                      <span>{{ item['name'] }}</span>
                    </span>
                  </template>
                </v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="handleRow"
      >
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="file-powerpoint"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin time-text">
              <span>{{ row.created_date }}</span><br>
              <span> {{ row.created_time }}</span>
            </div>
            <div class="flex  table-icon">
              <div v-if="row.company_id">
                <span
                  v-tooltip="row.company_language"
                  class="icon icon-content"
                >
                  <img
                    :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                  >
                </span>
              </div>
              <div>
                <span
                  v-tooltip="row.class_language"
                  class="icon icon-content"
                >
                  <font-awesome-icon
                    v-if="row.class_id&& row.product_id!==80"
                    :icon="getOptionName('iconOptions',row.class_id)" />
                  <font-awesome-icon
                    v-else
                    icon="cube" />
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{row}">
            <span class="break-word">{{row.plan}}</span>
            <p class="liter-text color-dark">{{row.period}}</p>
            <p
              v-if="row.pcy_no"
              class="liter-text">
              <span class="fw-600">Policy No. </span>
              <span>{{row.pcy_no}}</span>
            </p>
            <p
              v-if="row.order_sn"
              class="liter-text">
              <span class="fw-600">Ref. </span>
              <span>{{row.order_sn}}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column
          label="Account Name">
          <template #default="{ row }">
            <span class="break-word">{{row.isrd_nm}}</span>
            <p class="liter-text">{{row.mobile_no}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Hold Dollars">
          <template #default="{ row }">
            <span class="break-word">{{row.commission | formatMoney(2, false)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          :show-overflow-tooltip="true"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p>
                <span
                  class="span-status"
                  :class="{
                    'red': row.status == 3,
                    'green':[2].includes(row.status),
                    'blue': row.status == 1,
                  }">
                  {{ getOptionName('noClaimStatusList',row.status)}}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'
import {getNoClaimList,getNoClaimSummary} from '@api/claim'

export default {
  name: 'noClaimList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      search: null,
      date: [],
      status: [],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total',
          val: 0
        },
        pending: {
          name: 'Pending',
          val: 0
        },
        rejected: {
          name: 'Rejected',
          val: 0
        },
        redeemed: {
          name: 'Redeemed',
          val: 0
        },

      }
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        // let {policy={}} =  this.selectFilterData||{}
        // Object.keys(policy).forEach(item=>{
        //   this[item] = policy[item]
        // })
        // this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    }
  },
  async created(){
    await this.network().getNoClaimSummary()
    // await this.network().getList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handleRow(row){
      const { pcy_id, class_id, product_id,order_id} = row
      this.$router.push({
        path:'/records/policy/detail',
        query:{
          id:order_id,
          product_id,
          pcy_id
        }
      })
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'status':
          origin = 'noClaimStatusList'
          break
        default:
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerDown() {
      this.network().getList({
        is_export: 1
      })
    },

    network(){
      return {
        getNoClaimSummary: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
          }
          const { data } = await getNoClaimSummary(params)
          this.statistics.total.val = data.total
          this.statistics.pending.val = data.pending
          this.statistics.rejected.val = data.reject
          this.statistics.redeemed.val = data.redeemed
        },
        getList: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getNoClaimList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getNoClaimList(params)
            let {meta} = data||{}
            this.pageConfig.currentPage = meta.current_page
            this.pageConfig.total = meta.total
            this.tableData = data.data
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange{
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
      &.dark{
        background: #444D56;
      }
      &.blue{
        background: #0366D6;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.red {
      background: $red;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.orange{
      background: #E36209;
    }
    &.dark{
      background: #444D56;
    }
    &.blue{
      background:#0366D6;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.color-dark{
            color: $dark;
          }
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
.icon-color{
  color: #6A737D;
}
.table-icon{
  &.margin-top-flex{
    margin-top: 5px;
  }
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
  .backgroud-width{
    background: #fff!important;
    border: 1px solid #e1e4e8;
  }
}
</style>
